// The routes of the person's own datasets beside their documents
// (`/me/documents/datasets[/<id>|/new]`) and the way there from the Documents
// header. Datasets go with the documents; no sidebar section. The screens
// (personal.tsx) load when first opened.
import { type AnyRoute, createRoute, Link } from "@tanstack/react-router";
import { ME_DATASETS_PATH } from "@trameria/core/datasets-shared";
import { m } from "@trameria/i18n";
import { lazyScreen } from "../app/lazy";
import { Icon } from "../ui/icon";

/** The way from the documents to one's datasets (a header's button). */
export function MeDatasetsLink() {
  return (
    <Link
      aria-label={m.datasets_list()}
      to={ME_DATASETS_PATH}
      className="inline-flex h-[26px] flex-none items-center gap-1.5 rounded-[13px] px-2.5 text-[12.5px] font-normal tracking-normal text-muted hover:bg-hover hover:text-body"
    >
      <Icon kind="dataset" size={14} />
      {/* A list beside an open one is narrow: the mark alone keeps the title readable. */}
      <span className="hidden @min-[280px]:inline">{m.datasets_list()}</span>
    </Link>
  );
}

// Loaded when first opened.
const MeDatasetsLazy = lazyScreen(() => import("./personal"), "MeDatasets");
const MeDatasetLazy = lazyScreen(() => import("./personal"), "MeDataset");
const NewMeDatasetLazy = lazyScreen(() => import("./personal"), "NewMeDataset");

/** The routes of one's datasets under Me's main route (`/me/documents/datasets[/<id>|/new]`). */
export function meDatasetsRoutes(parent: AnyRoute): AnyRoute[] {
  const datasets = createRoute({
    getParentRoute: () => parent,
    path: "documents/datasets",
    component: MeDatasetsLazy,
  });
  // Nothing open: the list alone fills the panel.
  const list = createRoute({
    getParentRoute: () => datasets,
    path: "/",
    component: () => null,
  });
  const create = createRoute({
    getParentRoute: () => datasets,
    path: "new",
    component: NewMeDatasetLazy,
  });
  const open = createRoute({
    getParentRoute: () => datasets,
    path: "$datasetId",
    component: MeDatasetLazy,
  });
  return [datasets.addChildren([list, create, open])];
}
